import { FlexBox, Text } from '@dixa/lib-shared-habla';
import type { MainConversation } from 'lib-shared-types-api';
import { MouseEventHandler } from 'react';

import { ConversationChip } from 'components/conversation/conversationChip';
import { getConversationTitle } from 'utils/conversation';

type ConversationPreviewDetailsProps = {
  conversation: MainConversation;
  onNavigateToConversation?: MouseEventHandler<HTMLAnchorElement>;
};

export const ConversationPreviewDetails = ({
  conversation,
  onNavigateToConversation,
}: ConversationPreviewDetailsProps): JSX.Element => {
  const requester = conversation.authors[conversation.requested_by];

  const title = getConversationTitle({
    channel: conversation.initial_channel,
    direction: conversation.direction,
    subject: conversation.attributes.subject,
    requester,
  });

  return (
    <FlexBox
      flexWrap="wrap"
      alignItems="center"
      gap="200"
      flex="1"
      minWidth="0"
    >
      <FlexBox alignItems="center" minHeight="var(--dixa-size-spacer-500)">
        <ConversationChip
          csid={conversation.id}
          channel={conversation.initial_channel}
          status={conversation.status}
          popoverContentProps={{
            side: 'right',
          }}
          onNavigateToConversation={onNavigateToConversation}
        />
      </FlexBox>

      <Text.Paragraph flex="1 1 auto" variant="1">
        {title}
      </Text.Paragraph>
    </FlexBox>
  );
};
